/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Jr_1_DInputs */

const en_cp_jr_1_d = /** @type {(inputs: Cp_Jr_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A student club, a class or the Campus Lead invites anyone: idea → first PRD → one task verified live → three teams demo.`)
};

const id_cp_jr_1_d = /** @type {(inputs: Cp_Jr_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Himpunan, kelas, atau Campus Lead mengundang siapa saja: ide → PRD pertama → 1 task diverifikasi live → demo 3 tim.`)
};

/**
* | output |
* | --- |
* | "A student club, a class or the Campus Lead invites anyone: idea → first PRD → one task verified live → three teams demo." |
*
* @param {Cp_Jr_1_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_jr_1_d = /** @type {((inputs?: Cp_Jr_1_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Jr_1_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_jr_1_d(inputs)
	return en_cp_jr_1_d(inputs)
});